export default __webpack_public_path__ + "static/fulgencio-7d4308cb207e8215af0111db5a5f353b.png";